import { useQuery } from 'react-query'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { endpoints } from '@app/api/config'
import { ApiErrorResponse, ApiPlansResponse } from 'BackendApi'
import { getRandomExampleHeader } from '@app/api/utils/mock'

const fetchBillingPlans = async (): Promise<ApiPlansResponse> => {
  const apiResponse = await apiAuthClient.get(endpoints.getPlans, {
    headers: {
      ...getRandomExampleHeader([
        'full-plans',
        // 'new-pricing',
      ]),
    },
  })
  return apiResponse.data
}

export const useGetBillingPlans = () =>
  useQuery<ApiPlansResponse, ApiErrorResponse>(
    ['billingPlans'],
    fetchBillingPlans
  )
